import { useEffect, useState } from "react";
import { hdmgdjDefaultConfig, type HdmgdjConfig } from "@/config/hdmgdjConfig";

/**
 * 读取外置 JSON 配置（public/hdmgdj-config.json）。
 * 这样以后更换下载链接 / 联系邮箱，只需改线上的 JSON 文件，
 * 无需修改源码、无需重新打包。
 */
function resolveConfigUrl(): string {
  const base = (__BASE_PATH__ || "/").replace(/\/+$/, "");
  return `${base}/hdmgdj-config.json`;
}

export function useHdmgdjConfig(): { config: HdmgdjConfig; loading: boolean } {
  const [config, setConfig] = useState<HdmgdjConfig>(hdmgdjDefaultConfig);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const load = async () => {
      try {
        const res = await fetch(resolveConfigUrl(), { cache: "no-store" });
        if (!res.ok) {
          throw new Error(`config http ${res.status}`);
        }
        const data = (await res.json()) as Partial<HdmgdjConfig>;
        if (!active) {
          return;
        }
        const merged: HdmgdjConfig = {
          ...hdmgdjDefaultConfig,
          ...data,
          platforms:
            Array.isArray(data.platforms) && data.platforms.length > 0
              ? data.platforms
              : hdmgdjDefaultConfig.platforms,
        };
        setConfig(merged);
      } catch {
        // 读取失败时保留兜底配置，页面照常展示
        if (active) {
          setConfig(hdmgdjDefaultConfig);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      active = false;
    };
  }, []);

  return { config, loading };
}